// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Zerc7{display:flex;justify-content:center;padding:32px}.jeGg5{display:flex;flex-direction:column;gap:16px;width:100%;padding:24px;background:#fff;border-radius:16px;box-shadow:0px 4px 12px rgba(40,40,99,.06)}.uz_9Y{align-self:flex-start}.dU1y3{display:flex;justify-content:space-between;align-items:center;gap:16px}.TMwXc{display:flex;gap:24px;align-items:flex-start;margin-top:16px}.JzaKO{flex:1 1 320px;min-width:0;max-width:100%;display:flex;flex-direction:column;gap:24px}.v292k{flex:1 1 320px;min-width:0;max-width:100%}.N9bWl{margin:0}.uw9uh{display:inline-flex;align-items:center;cursor:pointer;color:#696992}.LoW6m{padding-left:28px;margin-top:-8px}.yaWnR{display:flex;justify-content:center}.GSv2A{align-self:flex-start;margin-top:0;margin-right:14px}.d8uJ8{margin-top:4px}.zgxPC{display:flex;align-items:center;justify-content:center;min-height:240px}.Ij7nN{display:block}.S9ZnR{padding-bottom:8px}.mpQtR{display:block}.mpQtR input:disabled,.mpQtR textarea:disabled,.mpQtR button:disabled,.mpQtR [aria-disabled=true]{pointer-events:none}.REIZc{text-align:right}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"radius0": `0px`,
	"radius2": `2px`,
	"radius4": `4px`,
	"radius8": `8px`,
	"radius12": `12px`,
	"radius16": `16px`,
	"radius20": `20px`,
	"radius24": `24px`,
	"spacing0": `0px`,
	"spacing2": `2px`,
	"spacing4": `4px`,
	"spacing8": `8px`,
	"spacing12": `12px`,
	"spacing16": `16px`,
	"spacing20": `20px`,
	"spacing24": `24px`,
	"spacing32": `32px`,
	"spacing40": `40px`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"contentPage": `Zerc7`,
	"modalContentWrapper": `jeGg5`,
	"addChargeButton": `uz_9Y`,
	"headerRow": `dU1y3`,
	"sectionsRow": `TMwXc`,
	"section": `JzaKO`,
	"sectionColumn": `v292k`,
	"sectionTitle": `N9bWl`,
	"tooltipIcon": `uw9uh`,
	"termsOfServiceIndent": `LoW6m`,
	"sendButtonRow": `yaWnR`,
	"emailContentAdornment": `GSv2A`,
	"fieldError": `d8uJ8`,
	"loadingWrapper": `zgxPC`,
	"restoredChargeRow": `Ij7nN`,
	"restoredChargeFooter": `S9ZnR`,
	"restoredChargeFieldTooltipAnchor": `mpQtR`,
	"amountCell": `REIZc`
};
export default ___CSS_LOADER_EXPORT___;
